export enum IconButtonVariants {
  Fill = 'FILL',
  Ghost = 'GHOST',
}
